export const borderOfSpanningSlot = (
  spanning: string | boolean,
): React.CSSProperties => {
  if (spanning === 'start') {
    return { borderRightStyle: 'dashed', borderRightWidth: '3px' };
  } else if (spanning === 'end') {
    return { borderLeftStyle: 'dashed', borderLeftWidth: '3px' };
  } else return {};
};
